import { Entity } from "../helpers/Entity"

export type Error = {
    canBeIgnored: boolean
    code: string
    message: string
    type: string
}

export type TerminalDtoAttributes = {
    externalId: string
    paymentAccountId: string
    brand: string
    model: string
    serialNumber: string
    deviceName: string
    createdAt: string
    createdBy: string
    updatedBy: string
    updatedAt: string
    deletedAt: string | null
    deletedBy: string | null
    isDeleted: string
    inUse: boolean
}

export type TerminalDto = {
    id: string
    type: string
    attributes: TerminalDtoAttributes
}

export default class Terminal implements Entity {
    private dto: TerminalDto

    constructor(dto: TerminalDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return !!this.dto.id
    }

    getId(): string {
        return this.dto.id
    }

    getExternalId(): string {
        return this.dto.attributes.externalId
    }

    getPaymentAccountId(): string {
        return this.dto.attributes.paymentAccountId
    }

    getName(): string {
        return this.dto.attributes.deviceName
    }

    getBrandAndModel(): string {
        return `${this.dto.attributes.brand} ${this.dto.attributes.model}`
    }

    getDto(): TerminalDto {
        return this.dto
    }

    getSerialNumber(): string {
        return this.dto.attributes.serialNumber
    }

    getCreatedAt(): string {
        return this.dto.attributes.createdAt
    }

    isInUse(): boolean {
        return this.dto.attributes.inUse
    }
}



// WEBPACK FOOTER //
// ./src/state/terminal/Terminal.ts